import React from 'react';

export default function Loading() {
    return (
        <div className='full-width content-height content-centered'>
            <div className='theme-max-width full-width content-centered'>
                <div className='loader'/>
            </div>
        </div>
    );
}